// The reschedule surface's binding of the shared expected-vs-unexpected classification
// (`me/expectedOutcome.ts`): its discriminator is the backend `ClientRescheduleError` code.
//
// The mechanism — and the reasoning behind it — lives in that module; this file is the outcome
// table lookup and nothing else.

import {
  apiErrorDetail,
  unexpectedDetail,
  unexpectedErrorDetail,
  type ExpectedFailure,
} from "../expectedOutcome";
import { RESCHEDULE_OUTCOMES, type RescheduleOutcome } from "./rescheduleCopy";

export type RescheduleFailure = ExpectedFailure<RescheduleOutcome>;

/** Re-exported so reschedule callers keep one import for the whole pattern. */
export { unexpectedErrorDetail };

/**
 * Classify one failure, or `null` when there is no error at all.
 *
 * `fallbackDetail` is what an unmapped NON-`Error` rejection reports; see
 * `unexpectedDetail` for why it must never be `null`.
 */
export function classifyRescheduleError(
  error: unknown,
  fallbackDetail = "",
): RescheduleFailure | null {
  if (!error) return null;
  const code = apiErrorDetail(error);
  const outcome = code === null ? undefined : RESCHEDULE_OUTCOMES[code];
  if (outcome) return { kind: "expected", outcome };
  return { kind: "unexpected", detail: unexpectedDetail(error, fallbackDetail) };
}
